// This file is used to create routes depending upon environments
import config from '../../config';
import store from '../store';
import APIService from './APIService';

export default class PreferencesService extends APIService {
  /**
   * To get preferences by preference key
   *
   * @param {string} preferenceKey
   */
  static getPreferencesByPreferenceKey(
    preferenceKey,
    pagingOptions = {},
    objId = null
  ) {
    let url = this.getPreferencesURL(preferenceKey, pagingOptions, objId);
    return this.get(url);
  }
  /**
   * To search preferences
   *
   * @param {string} preferenceKey
   * @param {string} searchText
   * @param {object} pagingOptions
   */
  static searchPreferences(preferenceKey, searchText, pagingOptions, objId) {
    let url = this.getPreferencesURL(preferenceKey, pagingOptions, objId);
    return this.post(url, {
      value: searchText
    });
  }
  /**
   * To add preference
   *
   * @param {string} preferenceKey
   * @param {object} objData
   * @param {string} onlyUrl
   */
  static addPreference(preferenceKey, objData, onlyUrl, id, objId) {
    let url = this.getPreferencesURL(preferenceKey, null, objId);
    const requestBody = {
      data: objData,
      removable: true
    };
    if (id && config.defaultPreferenceId !== id) {
      url = url + '/' + id;
    }

    return onlyUrl
      ? { url: url, method: 'put', body: requestBody }
      : this.put(url, requestBody);
  }
  /**
   * Return all concurrent preference
   *
   * @param {array} requests
   */
  static concurrentPreference(requests) {
    return this.all(requests);
  }
  // To remove preference
  static removePreference(objId) {
    let url = this.removePreferenceUrl(objId);
    return this.patch(url);
  }
  // To update preference
  static updatePreference(preferenceKey, id, objData, onlyUrl) {
    let url = this.updatePreferenceUrl(preferenceKey, id);
    const requestBody = {
      data: objData,
      removable: true
    };
    return onlyUrl
      ? { url: url, method: 'put', body: requestBody }
      : this.put(url, requestBody);
  }
  // To remove preference url
  static removePreferenceUrl(objId) {
    return `${config.baseUrlForPreferencesService}/preference/${objId}`;
  }
  // To update preference url
  static updatePreferenceUrl(preferenceKey, id) {
    let preferences = store.getters[
      'preferences/getPreferencesByPreferenceKey'
    ](preferenceKey);
    let objectId =
      preferences.scope === 'APP'
        ? 'xift'
        : preferences.scope === 'USER'
        ? store.state.userInformation?.userId
        : store.state.currentlySelectedOrgId;

    let category = preferences.category;

    let url = `${config.baseUrlForPreferencesService}/${preferences.scope}/${objectId}/preference/${category}/${preferenceKey}/${id}`;
    return url;
  }
  // To get preferences url
  static getPreferencesURL(preferenceKey, pagingOptions = null, objId = null) {
    /*
                - use getter from store to get preferences details for this key
                - based on {scope}, use userId or currentOrgId
                - once all details are available, create endpoint and fetch data
                - https://{baseUrl}/{scope}/{objectId}/preference/{category}/{preferenceKey}?pageNumber=1&pageable=true&size=10
            */
    // this will come from store getters
    let preferences = store.getters[
      'preferences/getPreferencesByPreferenceKey'
    ](preferenceKey);

    let objectId = '';
    if (objId) {
      objectId = objId;
    } else {
      objectId =
        preferences.scope === 'APP'
          ? 'xift'
          : preferences.scope === 'USER'
          ? store.state.userInformation?.userId
          : store.state.currentlySelectedOrgId;
    }
    let category = preferences.category;

    let url = `${config.baseUrlForPreferencesService}/${preferences.scope}/${objectId}/preference/${category}/${preferenceKey}`;

    if (pagingOptions) {
      let params = new URLSearchParams(pagingOptions);
      const query = params.toString();
      url = `${url}?${query}`;
    }

    return url;
  }
}
